define.alias("shared/components/shared/media/filter/filter-date-range", "calendar/components/shared/media/filter/filter-date-range");